(function () {
  var productUpcell = function () {
    function addp(id, qty, parent) {
      //console.log(id);
      $.ajax({
        type: "post",
        dataType: "json",
        url: "/cart/add.js",
        data: { quantity: qty, id: id },
        success: function (data) {
          jQuery.getJSON("/cart.js", function (cart) {
            $('.cart-count-bubble span[aria-hidden="true"]').html(
              cart.item_count
            );
          });
        },
      });
    }
 
    // $('.product-form__input-thickness label').on('click', function () {
    //   $('.product-form__input-dimension input').each(function () {
    //     if (!$(this).hasClass('disabled')) {
    //       var $element = $(this); // Store the current element in a variable
    //       var id = $element.attr('id');

    //       // Debounce-like functionality to prevent multiple triggers
    //       setTimeout(function () {
    //         var $targetLabel = $('.product-form__input-dimension').find('label[for="' + id + '"]');
    //         if ($targetLabel.length) {
    //           console.log('Triggering click on:', id);
    //           $targetLabel.trigger('click');
    //         }
    //       }, 800); // Adjust delay if necessary
    //     }
    //   });
    // });

    $(document).on("click", ".ctm-prodUpcell_add", function () {
      var id = $(this).data("id");
      var parent = $(this).closest(".productUpell_item");
      var qty = $(parent).find('input[type="number"]').val();
      $(this).addClass("hidden");
      $(parent).find(".ctm-prodUpcell_remove").removeClass("hidden");
      addp(id, qty, parent);
    });

    $(document).on("click", ".ctm-prodUpcell_remove", function () {
      var id = $(this).data("id");
      var parent = $(this).closest(".productUpell_item");
      var qty = $(parent).find('input[type="number"]').val();
      $(this).addClass("hidden");
      $(parent).find(".ctm-prodUpcell_add").removeClass("hidden");
      $.ajax({
        type: "post",
        dataType: "json",
        url: "/cart/change.js",
        data: {
          quantity: qty,
          id: id,
        },
        success: function (data) {
          jQuery.getJSON("/cart.js", function (cart) {
            $('.cart-count-bubble span[aria-hidden="true"]').html(
              cart.item_count
            );
          });
        },
      });
    });
  };
  var featuredReviewsSlider = function () {
    $(".reviewSlider").flickity({
      // options
      cellAlign: "left",
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: true,
    });
  };
  var accordion = function () {
    $(".accordion-warp")
      .find(".accordion-toggle")
      .click(function () {
        if (
          false == $(this).parent().find(".accordion-content").is(":visible")
        ) {
          // $('.accordion-box .accordion-toggle').removeClass('active');
          // $('.accordion-box .accordion-content').slideUp();
        }
        //Expand or collapse this panel
        $(this).toggleClass("active");
        $(this).parent().find(".accordion-content").slideToggle("fast");
      });
  };
  var blogSlider = function () {
    $(".blogSlider").flickity({
      // options
      cellAlign: "center",
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      groupCells: true,
    });
  };
  var Announcementslider = new Swiper(".announ_slider", {
    slidesPerView: 1,
    spaceBetween: 5,
    centeredSlides: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
  
    var rollLengthCalc = function () {
    // Function to calculate square footage and update quantity
    function calculateSquareFootage() {
      var width = parseFloat($("#txtWidth").val()) || 0;
      var length = parseFloat($("#txtLength").val()) || 0;
      var tileCoverage = $(".rrl__box").attr("data-coverage");

      var squareFeet = width * length;
      $("#txtsquareft").val(squareFeet);

      console.log(squareFeet);

      $(".optUptLength").html(length + "Ft");
      $(".optUptWidth").html(width + "Ft");

      if (width != 0 || length != 0) {
        $(".options-container").removeClass("hidden");
      } else {
        $(".options-container").addClass("hidden");
      }

      if ($("#tab-rrl").hasClass("turfCalc")) {
        updateProductInfoTurf(width, length);
      } else if ($(".rrl__box").hasClass("rrl__rosl")) {
        updateProductInfo(width, length);
      } else {
        // Update quantity based on square footage
        var quantity = Math.ceil(squareFeet / tileCoverage); // Adjust this calculation based on your needs
        $("#txtqty").val(quantity);
        $(".quantity__input").val(quantity);
        $(".qtyCalculater__qty .varRolls span").html(quantity);
        var price = $(
          ".product-price-box .price span.price-item.price-item--regular"
        ).html();
        var regex = /^(\D*)(.*)/;
        var m = regex.exec(price);
        var finalPrice = m[2] * quantity;
        $(".qtyCalculater__totalPrice span.price-item").html(
          m[1] + finalPrice.toFixed(2)
        );
      }
    }

    function updateProductInfo(width, length) {
      var size = width + "x" + length;

      if (width > 0) {
        const sizes = [10, 15, 20, 25, 30, 35, 40, 45, 50];
        let recomSize2, recomQty2;

        for (const size of sizes) {
          if (width >= size) {
            recomSize2 = `4'x${size}'`;
            recomQty2 = Math.round($("#txtsquareft").val() / (4 * size));
          } else {
            break;
          }
        }

        $(".recommendedOption2__Qty").html(recomQty2);
        $(".recommendedOption2__size").html(recomSize2);
      }

      if (length > 0) {
        const sizes = [10, 15, 20, 25, 30, 35, 40, 45, 50];
        let recomSize2, recomQty2;

        for (const size of sizes) {
          if (length >= size) {
            recomSize2 = `4'x${size}'`;
            recomQty2 = Math.round($("#txtsquareft").val() / (4 * size));
          } else {
            break;
          }
        }

        $(".recommendedOption1__Qty").html(recomQty2);
        $(".recommendedOption1__size").html(recomSize2);
      }
    }

    function updateProductInfoTurf(width, length) {
      var size = width + "x" + length;

      if (width > 0) {
        const sizes = [
          15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
          100,
        ];
        let recomSize2, recomQty2;

        for (const size of sizes) {
          if (width >= size) {
            recomSize2 = `15'x${size}'`;
            recomQty2 = Math.round(
              $("#txtsquareft").val() / (15 * size) + 0.5 - Number.EPSILON
            );
          } else {
            break;
          }
        }

        $(".recommendedOption2__Qty").html(recomQty2);
        $(".recommendedOption2__size").html(recomSize2);
      }

      if (length > 0) {
        const sizes = [
          15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
          100,
        ];
        let recomSize2, recomQty2;

        for (const size of sizes) {
          if (length >= size) {
            recomSize2 = `15'x${size}'`;
            recomQty2 = Math.round(
              $("#txtsquareft").val() / (15 * size) + 0.5 - Number.EPSILON
            );
          } else {
            break;
          }
        }

        $(".recommendedOption1__Qty").html(recomQty2);
        $(".recommendedOption1__size").html(recomSize2);
      }
    }

    // function compareSizes(size) {
    //   var sizes = []
    //   $('.product-form__input-size label').each(function () {
    //       var minSize = $(this).data('min-size');
    //       var size1Values = minSize.split('x');
    //         if( size >=  size1Values[1] ){
    //            console.log(minSize);
    //         }
    //     });
    // }

    // Bind the function to input change events
    $("#txtWidth, #txtLength").on("input", calculateSquareFootage);

    $(".options-container label").on("click", function () {
      var qty = $(this).find(".recoQty").html();
      var size = $(this).find(".recoSize").html();
      console.log(qty, size);
      //$('.product-form__input input[type=radio]+label[data-min-size="'+size+'"]').trigger('click');
      $('.size-dropDown-items div[value="' + size + '"]').trigger("click");
      $(".qtyCalculater__qty .varRolls span").html(qty);
      $(".qtyCalculater__qty .varTitle span").html(size);

      function numberWithCommas(x) {
        return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      }
      setTimeout(function () {
        var price = $(
          ".product-price-box .price span.price-item.price-item--regular"
        ).html();
        var regex = /^(\D*)(.*)/;
        var m = regex.exec(price);
        var Vprice = m[2].replace(/,/g, "");
        var finalPrice = Vprice * qty;
        $(".qtyCalculater__totalPrice span.price-item").html(
          m[1] + numberWithCommas(finalPrice.toFixed(2))
        );
        $(".quantity__input").val(qty);
      }, 1000);
    });
  };

  var trufQtySelect = function () {
    function turfSquareFootage() {
      var width = parseFloat($("#turfTxtWidth").val()) || 15;
      var length = parseFloat($("#turfTLength").val()) || 0;

      $(".trufQtySelecterInfo").html("");
      if (length > 100) {
        length = 100;
        $("#turfTLength").val(100); // Set input field value to 100 if it exceeds
        $(".trufQtySelecterInfo").html("Max length available is 100");
      }
      // if (length < 10) {
      //   $('.trufQtySelecterInfo').html('Minimum length is 10 feet');
      //   $('.product-form__submit').prop('disabled', true);
      // }
      // else{
      //   $('.product-form__submit').prop('disabled', false);
      // }
      $(".product-form__submit").prop("disabled", false);

      var squareFeet = width * length;
      $("#turfsquareft").html(squareFeet);

      $("#turfTxtWidthVal").val(width);
      $("#turfTLengthVal").val(length);
      $("#turfsquareftVal").val(squareFeet);

      console.log(squareFeet);

      // Update quantity based on square footage
      $(".quantity__input").val(squareFeet);
      var price = $(
        ".product-price-box .price span.price-item.price-item--regular"
      ).html();
      var regex = /^(\D*)(.*)/;
      var m = regex.exec(price);
      var finalPrice = m[2] * squareFeet;
      $("#turfsquareft_price").html(m[1] + finalPrice.toFixed(2));
    }

    $("#turfTxtWidth, #turfTLength").on("input", turfSquareFootage);
  };

var RollQtySelect = function () {
  if (window.EFSRollCalculator) { window.EFSRollCalculator.refresh(); return; }
  const selector = '.trufQtySelecter[data-efs-roll-calculator]';
  function formFor(box) {
    const id = box.dataset.formId;
    if (id && document.getElementById(id)) return document.getElementById(id);
    const scope = box.closest('.shopify-section');
    const candidates = scope ? Array.from(scope.querySelectorAll('form')).filter(f => f.querySelector('[name="properties[Total Area (sq. ft.)]"]')) : [];
    return candidates.length === 1 ? candidates[0] : null;
  }
  function boxFor(form) {
    return Array.from(document.querySelectorAll(selector)).find(box => formFor(box) === form);
  }
  function calculate(box) {
    const width = Number(box.querySelector('#rubberTxtWidth')?.value);
    const length = Number(box.querySelector('#rubberTLength')?.value);
    const rolls = Number(box.querySelector('#rollQty')?.value);
    if (width !== 4) throw new Error('Please select a valid roll width.');
    if (!Number.isInteger(length) || length < 10 || length > 100) throw new Error('Enter a whole-number roll length between 10 and 100 ft.');
    if (!Number.isSafeInteger(rolls) || rolls < 1) throw new Error('Enter a whole-number roll quantity of at least 1.');
    const area = width * length * rolls;
    if (!Number.isSafeInteger(area)) throw new Error('The requested area is too large.');
    return { width, length, rolls, area };
  }
  function set(form, name, value) {
    Array.from(form.elements).filter(el => el.name === name).forEach(el => { el.value = String(value); });
  }
  function sync(box, strict = false) {
    const form = formFor(box);
    const info = box.querySelector('.trufQtySelecterInfo');
    try {
      if (!form) throw new Error('Product form could not be found. Please reload the page.');
      const values = calculate(box);
      const variants = JSON.parse(box.querySelector('[data-efs-variants]').textContent);
      const variantId = form.elements.namedItem('id')?.value;
      const variant = variants.find(v => String(v.id) === String(variantId));
      if (!variant) throw new Error('Please select a product color.');
      const scope = box.closest('.shopify-section');
      const weightInput = scope?.querySelector('.productWeight');
      const unitWeight = weightInput ? Number(weightInput.value) : NaN;
      const properties = {
        'Width (ft)': values.width,
        'Length (ft)': values.length,
        'Total Area (sq. ft.)': values.area,
        'Quantity': values.rolls
      };
      if (Number.isFinite(unitWeight) && unitWeight >= 0) properties.Weight = (values.area * unitWeight).toFixed(2);
      else set(form, 'properties[Weight]', '');
      Object.entries(properties).forEach(([key, value]) => set(form, 'properties[' + key + ']', value));
      set(form, 'quantity', values.area);
      box.querySelector('#turfsquareft').textContent = values.area;
      box.querySelector('#turfsquareft_price').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: box.dataset.currency || 'USD' }).format(variant.price * values.area / 100);
      if (info) info.textContent = '';
      form.querySelector('[type="submit"]')?.classList.remove('disabled');
      return { ...values, properties };
    } catch (error) {
      if (info) info.textContent = error.message;
      if (form) {
        set(form, 'quantity', 0);
        ['Quantity', 'Total Area (sq. ft.)', 'Weight'].forEach(key => set(form, 'properties[' + key + ']', ''));
      }
      box.querySelector('#turfsquareft').textContent = '—';
      box.querySelector('#turfsquareft_price').textContent = '—';
      if (strict) throw error;
      return null;
    }
  }
  window.EFSRollCalculator = {
    refresh() { document.querySelectorAll(selector).forEach(box => sync(box)); },
    prepare(form) {
      const box = boxFor(form);
      if (!box) {
        if (form.querySelector('[data-efs-roll-form]')) throw new Error('Roll calculator is unavailable. Please reload this product page.');
        return null;
      }
      return sync(box, true);
    }
  };
  document.addEventListener('input', event => {
    const box = event.target.closest(selector);
    if (box && event.target.matches('#rollQty, #rubberTLength')) sync(box);
  });
  document.addEventListener('change', event => {
    const box = event.target.closest(selector);
    if (box && event.target.matches('#rollQty, #rubberTLength')) sync(box);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('.qtyUpdate');
    const box = button?.closest(selector);
    const input = button?.closest('.Quantity_box')?.querySelector('#rollQty');
    if (!button) return;
    if (!input) {
      const otherInput = button.closest('.Quantity_box')?.querySelector('.roll_quantity__input');
      if (otherInput) {
        event.preventDefault();
        const current = parseInt(otherInput.value, 10) || 1;
        otherInput.value = button.classList.contains('qtyplus') ? current + 1 : Math.max(1, current - 1);
        $(otherInput).trigger('change');
      }
      return;
    }
    if (!box) return;
    event.preventDefault();
    const current = Number(input.value);
    input.value = Math.max(1, (Number.isSafeInteger(current) ? current : 1) + (button.classList.contains('qtyplus') ? 1 : -1));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[name="id"], input[type="radio"], select')) {
      requestAnimationFrame(() => window.EFSRollCalculator.refresh());
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => window.EFSRollCalculator.refresh());
  }
  document.addEventListener('shopify:section:load', () => window.EFSRollCalculator.refresh());
  window.addEventListener('pageshow', () => window.EFSRollCalculator.refresh());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => window.EFSRollCalculator.refresh(), { once: true });
  else window.EFSRollCalculator.refresh();
};

  // $('.js-qty').on('input change', function() {
  //   var val = $(this).val();
  //   $('input[name="quantity"]').val(val); // hidden input sync
  // });

  $('.js-qty').on('input change', function() {
    var val = $(this).val();
    $(this).closest('.Quantity_box').find('.js-hidden-qty').val(val); // hidden input sync using class
  });

  var ctmSizeDropDown = function () {
    $(document).on("click", ".size-dropDown-head", function (e) {
      $(this).toggleClass("active"),
        $(this).parent().find(".size-dropDown-items").slideToggle();
    }),
      $(document).on("click", ".size-dropDown-items div", function (e) {
        var value = $(this).attr("value");
        var valueHTML = $(this).html();
        $(".size-dropDown-items div,.product-qty__info div").removeClass(
          "selected"
        );
        $(this).addClass("selected");
        $('.product-qty__info div[value="' + value + '"]').addClass("selected");
        $(this)
          .parents(".size-dropDown-box")
          .find(".size-dropDown-head .selected-val")
          .html(valueHTML),
          $(this)
            .parents(".size-dropDown-box")
            .find(".size-dropDown-head")
            .removeClass("active");
        $(this)
          .parents(".size-dropDown-box")
          .find(".size-dropDown-items")
          .hide(),
          $(".product-form__input")
            .find('input[type="radio"][value="' + value + '"]')
            .next()
            .trigger("click");
      });
  };

  var announcementSlider = function () {
    var play = $(".announcement-bar-Slider-new").attr("data-autoplay");
    var speed = $(".announcement-bar-Slider-new").attr("data-speed") * 1000;
    $(".announcement-bar-Slider-new").flickity({
      // options
      cellAlign: "left",
      groupCells: true,
      wrapAround: false,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: play,
      autoPlay: speed,
      pauseAutoPlayOnHover: false,
    });
  };

  var Imageslider = new Swiper(".img_slider", {
    centeredSlides: false,
    spaceBetween: 20,
    slidesPerView: 4.2,
    coverflowEffect: {
      rotate: 100,
      stretch: 60,
      depth: 50,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: ".pagin-img",
    },
    breakpoints: {
      320: {
        slidesPerView: 4.5,
        spaceBetween: 15,
      },
      640: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 7,
        spaceBetween: 24,
      },
    },
  });

  var compSlider = new Swiper(".comp_slider", {
    spaceBetween: 8,
    loop: false,
    centeredSlides: false,
    pagination: {
      el: ".comp-pagi",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 8,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4.1,
        spaceBetween: 0,
      },
    },
  });

  featuredReviewsSlider();
  accordion();
  blogSlider();
  rollLengthCalc();
  trufQtySelect();
  RollQtySelect();
  ctmSizeDropDown();
  announcementSlider();
  productUpcell();

  $(document).on("shopify:section:load", function (event) {
    featuredReviewsSlider();
    accordion();
    blogSlider();
    rollLengthCalc();
    trufQtySelect();
    RollQtySelect();
    ctmSizeDropDown();
    announcementSlider();
    productUpcell();
  
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  //$('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click')

  //$('.thumbnail-list .thumbnail-list__item:nth-child(2) .thumbnail').trigger('click');
  $("ul.tabs").each(function () {
    var active,
      content,
      contentMobil,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    contentMobil = $(active.data("mobi"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
      $($(this).data("mobi")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        contentMobil.hide();
        active = $(this);
        content = $($(this).attr("href"));
        contentMobil = $($(this).data("mobi"));
        active.addClass("active");
        content.show();
        contentMobil.show();
        return false;
      });
  });

  $(document).on("click", ".color-swatch", function () {
    var swatch = $(this).find(".swatch-overlay").html();
    var color = $(this).find(".swatch-overlay span").html();
    $(".swatchColor").html(swatch);
    $(".selectedColor span").html(color);
  });

  let observer; // Define observer outside the functions to be able to disconnect it

  function setUpMirroring() {
    const source = document.querySelector(".sqftPrice__box .price");
    const target = document.querySelector(".qtyCalculater__totalPrice");

    function mirrorContent(mutationsList) {
      for (let mutation of mutationsList) {
        // Check if the mutation is NOT on the target element to avoid infinite loop
        if (mutation.target !== target) {
          const currentSource = document.querySelector(
            ".sqftPrice__box .price"
          );
          if (currentSource && target) {
            target.innerHTML = currentSource.innerHTML;
          } else {
            console.error("Source or target element not found!");
          }
        }
      }
    }

    if (observer) {
      observer.disconnect(); // Disconnect the previous observer if it exists
    }

    observer = new MutationObserver(mirrorContent);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    }); // Observe the body for maximum coverage
  }

  function checkForUpcartRewards() {
    if (document.querySelector(".sqftPrice__box .price")) {
      setUpMirroring();
    } else {
      setTimeout(checkForUpcartRewards, 500);
    }
  }

  checkForUpcartRewards();
});

document.addEventListener("DOMContentLoaded", function () {
    const qtyInput = document.getElementById("rollQty");

    if (qtyInput) {
      // Prevent keyboard input
      qtyInput.addEventListener("keydown", function (e) {
        // Allow tab and arrow keys for accessibility
        const allowed = ["Tab", "ArrowUp", "ArrowDown"];
        if (!allowed.includes(e.key)) {
          e.preventDefault();
        }
      });

      // Prevent paste and drop
      qtyInput.addEventListener("paste", e => e.preventDefault());
      qtyInput.addEventListener("drop", e => e.preventDefault());
    }
});

// Custom arsal price and quantity update function JS

(function ($) {

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function getPriceData() {
    var priceText = $(".product-price-box .price span.price-item--regular")
      .first()
      .text()
      .trim();

    var regex = /^(\D*)(.*)/;
    var match = regex.exec(priceText);

    if (!match) return null;

    return {
      currency: match[1],
      value: parseFloat(match[2].replace(/,/g, "")) || 0
    };
  }

  function updateTotalPrice() {
    var priceData = getPriceData();
    if (!priceData) return;

    var qty = parseInt($(".quantity__input").val()) || 1;
    var total = priceData.value * qty;

    $(".qtyCalculater__totalPrice span.price-item").html(
      priceData.currency + numberWithCommas(total.toFixed(2))
    );
  }

  function resetQtySafely() {

    $(".quantity__input")
      .val(1)
      .prop("value", 1)
      .trigger("input")
      .trigger("change");

    $(".varRolls span").text(1);

    updateTotalPrice();
  }

  function bindEvents() {

    // Qty change
    $(document).on("input change", ".quantity__input", function () {
      updateTotalPrice();
    });

    // Variant / size change
    $(document).on(
      "click",
      ".size-dropDown-items div",
      function () {

        var value = $(this).attr("value");

        $(".product-form__input")
          .find('input[type="radio"][value="' + value + '"]')
          .next()
          .trigger("click");

        // wait until Shopify finishes ALL updates
        setTimeout(function () {

          $(".quantity__input").val(1).trigger("change");
          $(".varRolls span").text(1);

          updateTotalPrice();

        }, 250); // 🔥 increased delay (IMPORTANT)

      }
    );

    // MutationObserver (REAL FIX 🔥)
    // var priceBox = document.querySelector(".product-price-box");

    // if (priceBox) {
    //   var observer = new MutationObserver(function () {
    //     updateTotalPrice();
    //   });

    //   observer.observe(priceBox, {
    //     childList: true,
    //     subtree: true,
    //     characterData: true
    //   });
    // }
  }

  function init() {
    bindEvents();

    setTimeout(function () {
      updateTotalPrice();
    }, 300);
  }

  $(document).ready(function () {
    init();
  });

})(jQuery);